export const DEFAULT_CHAT_SIZE = { width: 370, height: 520 }

// The map supplies viewport coordinates; small maps take priority over the
// preferred minimum so the chat never spills into the results panel.
export function getChatGeometry (bounds, preferred = DEFAULT_CHAT_SIZE) {
  const inset = 30
  const maxWidth = Math.max(0, Math.min(bounds.width * 0.7, bounds.width - inset * 2))
  const maxHeight = Math.max(0, bounds.height - inset * 2)
  const minWidth = Math.min(320, maxWidth)
  const minHeight = Math.min(360, maxHeight)
  const width = Math.min(maxWidth, Math.max(minWidth, preferred.width))
  const height = Math.min(maxHeight, Math.max(minHeight, preferred.height))

  return {
    left: bounds.left + bounds.width - inset - width,
    top: bounds.top + bounds.height - inset - height,
    width,
    height,
    maxWidth,
    maxHeight
  }
}
